import { toISODate } from "../../utils/date";

const generateId = () => Math.random().toString(36).substr(2, 9);

const baseWorkout = (date, partial) => ({
    title: "",
    description: "",
    date: date || toISODate(new Date()),
    blocks: [],
    ...partial
});

export const getWorkoutTemplates = (date) => {
    return [
        {
            category: "Resistência",
            templates: [
                baseWorkout(date, {
                    title: "Treino Aeróbico Longo (Base)",
                    description: "Foco principal no desenvolvimento da base aeróbica e ritmo constante sem grande variação de frequência cardíaca.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquecimento",
                            sets: [
                                { id: generateId(), reps: 1, distance: 400, style: "Livre", intensity: "A1", interval: "Direto", description: "Nado contínuo e leve" },
                                { id: generateId(), reps: 4, distance: 50, style: "Livre", intensity: "A2", interval: "15''", description: "Educativos de braçada" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Principal",
                            sets: [
                                { id: generateId(), reps: 1, distance: 800, style: "Livre", intensity: "A2", interval: "Direto", description: "Manter ritmo de prova (70% FC Max)" },
                                { id: generateId(), reps: 4, distance: 100, style: "Medley", intensity: "A2", interval: "20''", description: "Soltando a musculatura" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Costas", intensity: "A1", interval: "Direto", description: "Desaquecimento" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Resistência com Palmar e Flutuador",
                    description: "Melhoria da força específica aeróbica usando implementos.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquecimento",
                            sets: [
                                { id: generateId(), reps: 1, distance: 300, style: "Livre", intensity: "A1", interval: "Direto", description: "Nado contínuo" },
                                { id: generateId(), reps: 4, distance: 50, style: "Costas", intensity: "A1", interval: "10''", description: "Foco no giro" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Principal",
                            sets: [
                                { id: generateId(), reps: 10, distance: 100, style: "Livre", intensity: "A2", interval: "15''", description: "Com palmar e flutuador" },
                                { id: generateId(), reps: 4, distance: 200, style: "Livre", intensity: "A2", interval: "20''", description: "Sem implementos, nadar longo" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A1", interval: "Direto", description: "Solto" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Fartlek (Variação de Ritmo Base)",
                    description: "Trabalho de resistência com quebras de ritmo (A1/A2).",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquece",
                            sets: [
                                { id: generateId(), reps: 1, distance: 400, style: "Livre", intensity: "A1", interval: "Direto", description: "Mesclando com Costas a cada 100m" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Principal",
                            sets: [
                                { id: generateId(), reps: 4, distance: 300, style: "Livre", intensity: "A1/A2", interval: "30''", description: "100 forte, 100 fraco, 100 forte" },
                                { id: generateId(), reps: 6, distance: 50, style: "Livre", intensity: "A2", interval: "10''", description: "Giro rápido" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Brilha", intensity: "A1", interval: "Direto", description: "Duplo costas / peito" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Resistência Progressiva",
                    description: "Nadando em blocos com ritmo caindo e mantendo técnica.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquece",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A1", interval: "Direto", description: "Leve" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Principal",
                            sets: [
                                { id: generateId(), reps: 4, distance: 200, style: "Livre", intensity: "A1", interval: "15''", description: "Tempo alvo + 5s" },
                                { id: generateId(), reps: 4, distance: 100, style: "Livre", intensity: "A2", interval: "10''", description: "Tempo alvo" },
                                { id: generateId(), reps: 4, distance: 50, style: "Livre", intensity: "A2+", interval: "15''", description: "Tempo alvo - 2s" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Finaliza",
                            sets: [
                                { id: generateId(), reps: 1, distance: 400, style: "Costas", intensity: "A1", interval: "Direto", description: "Bem solto" }
                            ]
                        }
                    ]
                })
            ]
        },
        {
            category: "Limiar",
            templates: [
                baseWorkout(date, {
                    title: "Limiar (Tiro Longo)",
                    description: "Trabalho de manutenção de ritmo no limiar (A3) em distâncias curtas a médias.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquecimento",
                            sets: [
                                { id: generateId(), reps: 1, distance: 400, style: "Livre", intensity: "A1", interval: "Direto", description: "" },
                                { id: generateId(), reps: 4, distance: 50, style: "Medley", intensity: "A2", interval: "15''", description: "Ordem Medley" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Principal A3",
                            sets: [
                                { id: generateId(), reps: 10, distance: 100, style: "Livre", intensity: "A3", interval: "1'30''", description: "Saída fixa com foco em manter 1'15''" },
                                { id: generateId(), reps: 1, distance: 200, style: "Costas", intensity: "A1", interval: "Direto", description: "Recuperação ativa" },
                                { id: generateId(), reps: 8, distance: 50, style: "Livre", intensity: "A3", interval: "50''", description: "Ritmo forte" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 300, style: "Livre/Costas", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Vo2 Max Curto",
                    description: "Tiros curtos com descanso mais longo buscando potência aeróbica máxima.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquece",
                            sets: [
                                { id: generateId(), reps: 1, distance: 300, style: "Livre", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Principal (Vo2)",
                            sets: [
                                { id: generateId(), reps: 4, distance: 100, style: "Livre", intensity: "Vo2", interval: "3'00''", description: "Tiro máximo, saída longa" },
                                { id: generateId(), reps: 1, distance: 400, style: "Livre", intensity: "A1", interval: "Direto", description: "Giro leve" },
                                { id: generateId(), reps: 4, distance: 100, style: "Principal", intensity: "Vo2", interval: "2'45''", description: "Tiro máximo no estilo principal" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Costas", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Limiar Fracionado 200s",
                    description: "Séries de 200 repetições buscando sustentação do ácido lático.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquecimento",
                            sets: [
                                { id: generateId(), reps: 1, distance: 600, style: "Livre", intensity: "A1/A2", interval: "Direto", description: "Progressivo" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Principal A3",
                            sets: [
                                { id: generateId(), reps: 5, distance: 200, style: "Livre", intensity: "A3", interval: "30''", description: "Manter FC ~85%" },
                                { id: generateId(), reps: 1, distance: 100, style: "Livre", intensity: "A1", interval: "Direto", description: "Solto" },
                                { id: generateId(), reps: 4, distance: 100, style: "Livre", intensity: "A3", interval: "15''", description: "Passagem forte" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Medley", intensity: "A1", interval: "Direto", description: "Sendo 50m cada, bem leve" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Pirâmide Limiar",
                    description: "Sobe e desce as distâncias mantendo as batidas lá em cima.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquece",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A1", interval: "Direto", description: "" },
                                { id: generateId(), reps: 4, distance: 50, style: "Livre", intensity: "A2", interval: "10''", description: "Pernada" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Pirâmide Principal",
                            sets: [
                                { id: generateId(), reps: 1, distance: 100, style: "Livre", intensity: "A3", interval: "15''", description: "" },
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A3", interval: "20''", description: "" },
                                { id: generateId(), reps: 1, distance: 300, style: "Livre", intensity: "A3", interval: "30''", description: "" },
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A3", interval: "20''", description: "" },
                                { id: generateId(), reps: 1, distance: 100, style: "Livre", intensity: "A3", interval: "15''", description: "" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 300, style: "Livre", intensity: "A1", interval: "Direto", description: "Nado contínuo" }
                            ]
                        }
                    ]
                })
            ]
        },
        {
            category: "Velocidade",
            templates: [
                baseWorkout(date, {
                    title: "Velocidade Pura (Sprints)",
                    description: "Tiros muito curtos na máxima com muito descanso. Sistema CP (Alático).",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquecimento",
                            sets: [
                                { id: generateId(), reps: 1, distance: 400, style: "Livre", intensity: "A1", interval: "Direto", description: "" },
                                { id: generateId(), reps: 4, distance: 25, style: "Livre", intensity: "A2", interval: "15''", description: "Educativos de explosão" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Velocidade (AN AL)",
                            sets: [
                                { id: generateId(), reps: 6, distance: 25, style: "Livre", intensity: "MáxM", interval: "1'30''", description: "Máxima (Sprint) sem respirar" },
                                { id: generateId(), reps: 1, distance: 300, style: "Costas", intensity: "A1", interval: "Direto", description: "Giro leve" },
                                { id: generateId(), reps: 6, distance: 25, style: "Principal", intensity: "MáxM", interval: "1'30''", description: "Sprint do seu melhor estilo" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A1", interval: "Direto", description: "Bem leve" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Potência a Lactato",
                    description: "Tiros lácticos em distâncias curtas, mantendo frequência nas alturas.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquece",
                            sets: [
                                { id: generateId(), reps: 1, distance: 300, style: "Livre", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Série Lática",
                            sets: [
                                { id: generateId(), reps: 4, distance: 50, style: "Livre", intensity: "TOL", interval: "1'00''", description: "Tiro Lactato" },
                                { id: generateId(), reps: 1, distance: 100, style: "Livre", intensity: "A1", interval: "Direto", description: "Recupera A1" },
                                { id: generateId(), reps: 4, distance: 50, style: "Medley", intensity: "TOL", interval: "1'00''", description: "Tiro Lactato 2" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Finaliza",
                            sets: [
                                { id: generateId(), reps: 1, distance: 300, style: "Costas", intensity: "A1", interval: "Direto", description: "Recuperação total" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Treino Paraquédas / Equipamentos",
                    description: "Nado tracionado e resistido focando em ganho rápido de potência.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquecimento Geral",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Tracionado",
                            sets: [
                                { id: generateId(), reps: 6, distance: 25, style: "Livre", intensity: "Veloc", interval: "1'00''", description: "Com Paraquedas / Elastico" },
                                { id: generateId(), reps: 1, distance: 200, style: "Costas", intensity: "A1", interval: "Direto", description: "Sem implemento" },
                                { id: generateId(), reps: 6, distance: 25, style: "Livre", intensity: "Veloc", interval: "1'00''", description: "Pé de pato e palmar, máxima" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Repetições Láticas de 100m",
                    description: "Tolerância extrema a lactato com recuperação demorada.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Giro A1",
                            sets: [
                                { id: generateId(), reps: 1, distance: 400, style: "Livre", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Principal (AN LT)",
                            sets: [
                                { id: generateId(), reps: 4, distance: 100, style: "Livre", intensity: "TOL", interval: "4'00''", description: "Saídas a 4 minutos, Máxima velocidade." }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Soltura",
                            sets: [
                                { id: generateId(), reps: 1, distance: 300, style: "Costas", intensity: "A1", interval: "Direto", description: "Fundamental muita soltura após lático." }
                            ]
                        }
                    ]
                })
            ]
        },
        {
            category: "Técnica",
            templates: [
                baseWorkout(date, {
                    title: "Recuperação Ativa Longa",
                    description: "Ideal para o dia após competição ou treinos lactáticos. Ênfase no relaxamento da braçada.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Giro Integral",
                            sets: [
                                { id: generateId(), reps: 1, distance: 800, style: "Livre/Costas", intensity: "A1", interval: "Direto", description: "Nadando super solto" },
                                { id: generateId(), reps: 4, distance: 100, style: "Medley", intensity: "A1", interval: "15''", description: "Mudando os estímulos musculares suavemente" },
                                { id: generateId(), reps: 8, distance: 50, style: "Borboleta/Costas", intensity: "A1", interval: "15''", description: "Foca no deslize" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Desenvolvimento de Pernada",
                    description: "Treino que força os membros inferiores e estabilidade do Core.",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquece",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Série Principal (Pernada)",
                            sets: [
                                { id: generateId(), reps: 10, distance: 50, style: "Livre", intensity: "A2", interval: "15''", description: "Somente pernada com Prancha" },
                                { id: generateId(), reps: 6, distance: 100, style: "Costas", intensity: "A2", interval: "15''", description: "Pernada submersa na virada" },
                                { id: generateId(), reps: 4, distance: 50, style: "Peito", intensity: "A2", interval: "10''", description: "Pernada com joelho travado" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Compensação",
                            sets: [
                                { id: generateId(), reps: 1, distance: 400, style: "Livre", intensity: "A1", interval: "Direto", description: "Nado completo, focando braçada" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Filmagens e Correções (Técnica)",
                    description: "Treino misto focado em perfeição motora (Giro Baixo).",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Aquece",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Foco no Deslize",
                            sets: [
                                { id: generateId(), reps: 8, distance: 50, style: "Livre", intensity: "A1", interval: "15''", description: "Contar número de braçadas" },
                                { id: generateId(), reps: 4, distance: 50, style: "Medley", intensity: "A1", interval: "20''", description: "Palmateios" },
                                { id: generateId(), reps: 8, distance: 25, style: "Costas", intensity: "A1", interval: "15''", description: "Cotovelo alto, filmagem lateral" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Solto Fim",
                            sets: [
                                { id: generateId(), reps: 1, distance: 200, style: "Livre", intensity: "A1", interval: "Direto", description: "" }
                            ]
                        }
                    ]
                }),
                baseWorkout(date, {
                    title: "Hipoventilação e Capacidade Pulmonar",
                    description: "Exercícios de apneia submersa limitando respiração",
                    blocks: [
                        {
                            id: generateId(),
                            name: "Leve Aquece",
                            sets: [
                                { id: generateId(), reps: 1, distance: 400, style: "Livre", intensity: "A1", interval: "Direto", description: "Respiração bilateral" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Hipoventilação",
                            sets: [
                                { id: generateId(), reps: 4, distance: 100, style: "Livre", intensity: "A2", interval: "15''", description: "Revezando 3x1, 5x1, 7x1, 9x1 respiradas." },
                                { id: generateId(), reps: 4, distance: 50, style: "Borboleta", intensity: "A2", interval: "20''", description: "Sem respirar os últimos 25m" }
                            ]
                        },
                        {
                            id: generateId(),
                            name: "Volta a Calma",
                            sets: [
                                { id: generateId(), reps: 1, distance: 300, style: "Livre/Costas", intensity: "A1", interval: "Direto", description: "Giro super tranquilo para recuperar Oxigenação." }
                            ]
                        }
                    ]
                })
            ]
        }
    ];
};
